export default class waitingTimeDrawer {
    constructor() {
        // the single element of the drawer specifies the timeframe 
        // being 60.0 = 60 seconds
        // Example: [ 120.0, 120.0, 120.0, 180.0, 0.0 ] --> [ 1-3 min, 3-5 min, 5-7 min, 7-10 min, 10 min]
        this.drawers = [ 120.0 , 120.0, 300.0, 0.0];
        this.startingTime = 60.0;
    }

    getDrawer(seconds) {
        if (seconds < 0) {
            seconds = Number.MAX_VALUE;
        }
        let start = this.startingTime;
        for (let timeframe of this.drawers) {
            if (seconds <= start + timeframe) {
                return Math.floor(start/60.0) + " - " + Math.floor((start + timeframe)/60.0);
            }
            start = start + timeframe;
        }
        return Math.floor(start/60.0);
    }
}